import { print } from "graphql";
import { Client } from "graphql-ws";
import { OrderSubscriptionSummaryFragment } from "./fragments/order-subscription-summary";
import { getOrderQueryKey } from "./use-get-order";
import {
	SubscribeToOrderDocument,
	SubscribeToOrderSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToOrder($orderId: ObjectID, $ref: String) {
			subscribeToOrder(orderId: $orderId, ref: $ref) {
				type
				id
				payload {
					...OrderSubscriptionSummary
				}
			}
		}
		${OrderSubscriptionSummaryFragment}
	`
);

export const subscribeToOrder = (
	client: Client,
	{ orderId, orderRef }: { orderId?: string; orderRef?: string },
) =>
	client.subscribe<SubscribeToOrderSubscription>(
		{
			query: print(SubscribeToOrderDocument),
			variables: { orderId, ref: orderRef },
		},
		{
			next: async (result) => {
				if (result.data) {
					const { type, payload } = result.data.subscribeToOrder;
					if (type === "delete" || !payload) return;

					const queryKey = getOrderQueryKey(orderId ?? orderRef);
					await queryClient.invalidateQueries({ queryKey, exact: true });
				}
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
